import React from 'react';
import { ProcessSteps } from './ProcessSteps';
import { PROCESS_BODY, PROCESS_TITLE, REVEAL_BODY, REVEAL_NEW_QUESTION, REVEAL_OLD_QUESTION, REVEAL_TITLE } from '../data/poolContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-pool/20 bg-black py-14 sm:py-20" aria-labelledby="reveal-title" data-id="element-307" data-mp="1kzt8trlhiakt">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-308" data-mp="1ba9o0ge7o6nb">
        <h2 id="reveal-title" className="font-display text-[2.2rem] font-bold uppercase leading-none text-frost-50 sm:text-[3.2rem]" data-id="element-309" data-mp="1b8oosdgybzj4">
          {REVEAL_TITLE}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-310" data-mp="12begn0zfkqif">
          {REVEAL_BODY}
        </p>

        <div className="mx-auto mt-10 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-311" data-mp="sbdwjctqm6d6">
          <div className="rounded-2xl border border-abyss-600 bg-abyss-900 px-6 py-6" data-id="element-312" data-mp="sdgr8a5u4no8">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-313" data-mp="x9p23bd01upl">
              Instead of starting with
            </p>
            <p className="mt-2 font-display text-[1.6rem] font-semibold uppercase leading-tight text-body line-through decoration-alert/70" data-id="element-314" data-mp="2xjzlco83r9k2">
              {REVEAL_OLD_QUESTION}
            </p>
          </div>
          <div className="rounded-2xl border border-aqua/50 bg-abyss-900 px-6 py-6" data-id="element-315" data-mp="37hdz2g2n5k8o">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-aqua" data-id="element-316" data-mp="2jrjok55so7rl">
              You’ll learn to start with
            </p>
            <p className="mt-2 font-display text-[1.6rem] font-bold uppercase leading-tight text-frost-50" data-id="element-317" data-mp="2eut9nl5q7i7r">
              {REVEAL_NEW_QUESTION}
            </p>
          </div>
        </div>

        <ProcessSteps className="mt-12" data-id="element-318" data-mp="2ns3kx6ijn7co" />

        <p className="mt-10 font-display text-[1.7rem] font-bold uppercase text-frost-50 sm:text-[2rem]" data-id="element-319" data-mp="2042ga8ohkb2j">
          {PROCESS_TITLE}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-[15px] leading-relaxed text-body" data-id="element-320" data-mp="1w1filr54vvxf">
          {PROCESS_BODY}
        </p>
      </div>
    </section>;
}